export const ISO_DATE_FORMAT = 'YYYY-MM-DD';

export const DAY_MONTH_YEAR = 'DD MMM YYYY';
export const MONTH_YEAR = 'MMM YYYY';
export const LONG_MONTH_YEAR = 'MMMM YYYY';

export const DAY_MONTH_YEAR_SLASH = 'DD/MM/YYYY';
export const YEAR_MONTH_DAY_SLASH = 'YYYY/MM/DD';
export const YEAR_MONTH_DAY_DASH = 'YYYY-MM-DD';
export const HOURS_MINUTES_COLON = 'HH:mm';
export const HOURS_MINUTES_SECONDS_COLON = 'HH:mm:ss';
export const SENDIND_REMINDER_DATE_FORMAT = 'DD/MM @ HH:mm UTC';
